class Hero extends BaseHero {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-swiper]');
        this.productSwiperEl = this.$find('[data-product-swiper]');
        this.prevButton = this.$find('[data-swiper-prev]');
        this.nextButton = this.$find('[data-swiper-next]');
        this.swiper = null;
        this.productSwiper = null;
        this.swiperEl && this.constructSwiper();
        this.productSwiperEl && this.constructProductSwiper();
        this.swiper && this.productSwiper && this.linkSwipers();
        this.addEventListeners();
    }

    linkSwipers() {
        this.swiper.controller.control = this.productSwiper;
        this.productSwiper.controller.control = this.swiper;
    }

    constructProductSwiper() {
        this.productSwiper = new Swiper(this.productSwiperEl, {
            watchOverflow: true,
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 30,
        });
    }

    addEventListeners() {
        if (this.prevButton) {
            this.prevButton.addEventListener('click', () => {
                this.swiper.slidePrev();
            });
        }

        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => {
                this.swiper.slideNext();
            });
        }
    }
}

